"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var s = require("./OldProductImage.scss");
var OldProductImage = /** @class */ (function (_super) {
    tslib_1.__extends(OldProductImage, _super);
    function OldProductImage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getImage = function () {
            var _a;
            var _b = _this.props, imageMode = _b.imageMode, className = _b.className, mountedToDOM = _b.mountedToDOM, productName = _b.productName, altText = _b.altText, imgDataHook = _b.imgDataHook, src = _b.src, imageLoaded = _b.imageLoaded;
            var imageClass = classnames_1.default([
                (_a = {},
                    _a[s.imageBeforeMounted] = !mountedToDOM,
                    _a[s.imageModeFit] = imageMode === 2 /* FIT */,
                    _a[s.imageModeCrop] = imageMode === 1 /* CROP */,
                    _a),
                className,
            ]);
            return (React.createElement("img", { src: src, alt: altText || productName, "data-hook": imgDataHook, className: imageClass, onLoad: imageLoaded }));
        };
        return _this;
    }
    OldProductImage.prototype.render = function () {
        var _a;
        var _b = this.props, imageMode = _b.imageMode, mountedToDOM = _b.mountedToDOM, style = _b.style, containerDataHook = _b.containerDataHook;
        var imageContainerClass = classnames_1.default([
            s.imageContainer,
            (_a = {},
                _a[s.imageContainerModeFit] = imageMode === 2 /* FIT */,
                _a[s.imageContainerModeCrop] = imageMode === 1 /* CROP */,
                _a),
        ]);
        return (React.createElement("div", { "data-hook": containerDataHook, style: style, className: imageContainerClass }, mountedToDOM && this.getImage()));
    };
    return OldProductImage;
}(React.Component));
exports.OldProductImage = OldProductImage;
//# sourceMappingURL=OldProductImage.js.map